import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import settings from "@/scripts/common/settings"
import utilities from "@/scripts/common/utilities"
import {Loader} from '@/scripts/infinite-loader/Infinite-loader'
import Pin from '@/scripts/pin/Pin'
import {addScrollController, ScrollControllers} from "@/scripts/common/api/scrolltrigger.services"

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)


export const Blogs = (() => {
    const CLASS_PRE = 'blog-listing'

    class BlogListing {
        constructor(container) {
            this.$blog = container
            this.$blogFilter = this.$blog.querySelector(`.${CLASS_PRE}__filter`)
            this.$blogListingContent = this.$blog.querySelector(`.${CLASS_PRE}__content`)
            this.$blogFeaturedCol = this.$blog.querySelector(`.${CLASS_PRE}__col--featured`)
            this.$blogAsideCol = this.$blog.querySelector(`.${CLASS_PRE}__col--aside`)
            this.$blogFeaturedArticle = this.$blog.querySelector(`.blog-article--featured`)

            
            this.scrollTweenController = null
            this.isMobile = window.innerWidth < settings.breakpoints.mobile

            this.scrollTweenOption = {
                trigger: this.$blogFeaturedCol,
                start: 'top top'
            }

            this.pinOptions = { // Pin overrides
                start: 'bottom bottom'
            }

            this.pin = null
            this.pinTl = null
            this.init()
        }

        init() {
            new Loader.InfiniteLoader(this.$blogAsideCol) // Infinite loader
            if (!this.isMobile) this.pin = new Pin(this.$blogFeaturedArticle, this.$blog, this.pinOptions) // Pining featured article
            //if (this.isMobile) this.createPinTl()
            this.updateOptions()
            this.addToSCrollController()
            this.addListeners()
        }

        // Animation
        createPinTl() {
            if(this.pinTl) {
                this.pinTl.kill()
                this.pinTl = null
            }

            this.pinTl = gsap.timeline()

            this.pinTl.to(this.$blogFeaturedArticle, {
                autoAlpha: 0,
                scale: 0.5
            })
        }

        // Refresh Pin
        refresh() {
            if (this.pin) this.pin.refresh()
            if (this.scrollTweenController) this.scrollTweenController.refresh()
        }


        // Option updates
        updateOptions() {
            if (this.pinTl)
                Object.assign(this.scrollTweenOption, {
                    animation: this.pinTl,
                    scrub: true
                })
        }


        // Adding scrollController
        addToSCrollController() {
            if (this.scrollTweenController) this.scrollController = null

            if(this.pinTl) {
                this.scrollTweenController = ScrollTrigger.create(this.scrollTweenOption) // For mobile pin animation
                addScrollController(this.scrollTweenController)
            }
        }

        // Resize func
        resizeFunc() {
            return utilities.debounce(() => {
                this.isMobile = window.innerWidth < settings.breakpoints.mobile
                this.refresh()
            }, 250)
        }

        // Adding Listeners
        addListeners() {
            this.$blogAsideCol.addEventListener('onUpdate', () => this.refresh())
            window.addEventListener('resize', this.resizeFunc())
        }
    }

    return {
        BlogListing
    }
})()

export default Blogs